import service from "@irati/utils/tracking/index";
var getTileData = function (tile) {
    var i = tile.i, widgetId = tile.widgetId, link = tile.link, openLinkInNewTab = tile.openLinkInNewTab, type = tile.type;
    return {
        tile_type: type,
        tile_link: link,
        tile_link_in_new_tab: openLinkInNewTab,
        tile_id: i || widgetId
    };
};
var tracking = {
    clickTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_click_tile", data);
    },
    startEdit: function () {
        service.trackPlatformEvent("customisable_homepage_start_edit", {});
    },
    publish: function () {
        service.trackPlatformEvent("customisable_homepage_publish", {});
    },
    startAddTile: function (tile_type) {
        var data = {
            tile_type: tile_type
        };
        service.trackPlatformEvent("customisable_homepage_start_add_tile", data);
    },
    cancelAddTile: function () {
        service.trackPlatformEvent("customisable_homepage_cancel_add_tile", {});
    },
    completeAddTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_complete_add_tile", data);
    },
    startEditTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_start_edit_tile", data);
    },
    completeEditTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_complete_edit_tile", data);
    },
    cancelEditTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_cancel_edit_tile", data);
    },
    editError: function (error_text) {
        var data = {
            error_text: error_text
        };
        service.trackPlatformEvent("customisable_homepage_edit_error", data);
    },
    startDeleteTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_start_delete_tile", data);
    },
    completeRemoveTile: function (tile) {
        var data = getTileData(tile);
        service.trackPlatformEvent("customisable_homepage_complete_delete_tile", data);
    }
};
export default tracking;
